/**
 * Onboarding storage utilities
 * Handles storing and retrieving onboarding progress
 */

const ONBOARDING_STORAGE_KEY = "waritto-onboarding";

export interface OnboardingState {
  hasSeenWelcome: boolean;
  hasCreatedFirstGroup: boolean;
  hasAddedFirstExpense: boolean;
  hasInvitedMember: boolean;
}

const defaultState: OnboardingState = {
  hasSeenWelcome: false,
  hasCreatedFirstGroup: false,
  hasAddedFirstExpense: false,
  hasInvitedMember: false,
};

export function getOnboardingState(): OnboardingState {
  if (typeof window === "undefined") return defaultState;
  try {
    const saved = localStorage.getItem(ONBOARDING_STORAGE_KEY);
    if (saved) {
      return { ...defaultState, ...JSON.parse(saved) };
    }
  } catch {
    // Ignore errors
  }
  return defaultState;
}

export function saveOnboardingState(state: OnboardingState): void {
  try {
    localStorage.setItem(ONBOARDING_STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Ignore errors
  }
}

export function getDefaultOnboardingState(): OnboardingState {
  return { ...defaultState };
}
